var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.num),function(item,index){return _c('div',{key:index,staticClass:"span"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }